import React from 'react';
import { ConfiguratorUIElementStates } from '@/elements/base/ElementState';
import { IUICfgRootContainer } from '@canvas-logic/clp-api-types';
import { ContainerLevelContext } from '@/ui-kit/contexts/ContainerLevelContext';
import { gapLevelToCssValue } from '@/elements/shared/gapUtils';
import { ElementRenderer } from '@/elements/ElementRenderer';

interface RootContainerCfgUIElementProps {
  viewElement: IUICfgRootContainer;
  childrenItems: ConfiguratorUIElementStates[];
}

export const RootContainerCfgUIElement: React.FC<RootContainerCfgUIElementProps> = ({ viewElement, childrenItems }) => {
  // Root container is always level 1, but read from viewElement if set by virtualLayoutBuilder
  const level = (viewElement as any)._level ?? 1;

  const groupGapCss = gapLevelToCssValue(viewElement.groupGapLevel);

  return (
    <ContainerLevelContext.Provider value={level}>
      <div
        className="cp-root-container"
        data-element-id={viewElement.id}
        data-container-type="root"
        data-container-level={level}
      >
        <div
          className="cp-root-container__content"
          style={groupGapCss ? ({ '--container-gap': groupGapCss } as React.CSSProperties) : undefined}
        >
          {childrenItems.map((child) => (
            <ElementRenderer key={child.id} state={child} />
          ))}
        </div>
      </div>
    </ContainerLevelContext.Provider>
  );
};
